/* Shared look of every text-entry control (single line, multi line, select trigger). */
.control {
  width: 100%;
  min-width: 0;
  min-height: var(--control-md);
  padding: 0 var(--space-3);
  border: var(--border-width) solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface-raised);
  color: var(--color-text);
  font-size: var(--text-md);
  transition:
    border-color var(--duration-fast) var(--ease-standard),
    box-shadow var(--duration-fast) var(--ease-standard);
}

/* 16px text keeps iOS Safari from zooming into a focused field. */
@media (pointer: coarse) {
  .control {
    font-size: 1rem;
  }
}

.control::placeholder {
  color: var(--color-text-subtle);
}

.control:hover:not(:disabled) {
  border-color: var(--color-text-subtle);
}

.control:focus-visible,
.control:focus {
  outline: none;
  border-color: var(--color-focus);
  box-shadow: 0 0 0 1px var(--color-focus);
}

.control[aria-invalid="true"] {
  border-color: var(--color-danger);
}

.control:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.multiline {
  padding-block: var(--space-2);
  line-height: var(--leading-normal);
  resize: none;
}

.withTrailing {
  position: relative;
  display: flex;
  align-items: center;
}

.withTrailing .control {
  padding-right: calc(var(--control-md) + var(--space-1));
}

.trailing {
  position: absolute;
  right: var(--space-0-5);
}
